export const PWA_APP_NAME_MAX_LENGTH = 12;

export const STAFF_ADD_TO_HOME_SCREEN_SCOPE = 'staff';

export const IOS_ADD_TO_HOME_SCREEN_VIDEO_URL =
  'https://files.salovare.com/tutorial%20home%20screen%20app.mp4';
